module.exports = __webpack_public_path__ + "static/media/Mulish-VariableFont_wght.2ea3e31b.ttf";